import { Component, computed, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { AudioVideoCheckSelectors } from 'src/app/features/av-check/store/selectors';
import { PackageUsersSelectors } from 'src/app/features/package-users';

import { SessionHandoffActions } from '../../store/actions';
import { getAssociatedUsers } from '../../store/selectors/session-handoff.selectors';
import { CheckInActions } from 'src/app/features/check-in/store/actions';
import { CheckInSelectors } from 'src/app/features/check-in/store';

@Component({
  selector: 'app-session-handoff-page',
  templateUrl: './session-handoff-page.component.html',
  styleUrls: ['./session-handoff-page.component.scss'],
  standalone: false,
})
export class SessionHandoffPageComponent implements OnInit {
  private readonly needsAvCheck = this.store.selectSignal(
    AudioVideoCheckSelectors.getDoesAvCheckNeedToBeCompletedInSession
  );

  associatedUsers = this.store.selectSignal(getAssociatedUsers);
  participants = this.store.selectSignal(PackageUsersSelectors.selectNonSigningAgentsWithFullNames);
  usersInWaitingRoom = this.store.selectSignal(CheckInSelectors.getUsersViewedWaitingRoom);

  continueButtonText = computed(() =>
    this.needsAvCheck() ? 'Set up your device' : 'Join notary session'
  );

  hasAssociatedUsers = computed(() => {
    const participants = this.participants() ?? [];
    const associated: string[] = this.associatedUsers() ?? [];
    
    return associated.some((associatedGuid) =>
      participants.some((p) => p.packageUserGuid.toLowerCase() === associatedGuid.toLowerCase())
    );
  });

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(CheckInActions.NonSigningAgentWelcomePageOpened());
    this.store.dispatch(SessionHandoffActions.ActivateSessionHandoff());
  }

  onJoinSession(packageUserGuid: string): void {
    this.store.dispatch(SessionHandoffActions.JoinSession({ payload: { packageUserGuid } }));
  }

  onContinue(): void {
    this.store.dispatch(SessionHandoffActions.ContinueToSession());
  }
}
